<template>
    <DCard
        padding
    >
        <Form
            :errors="errors"
            :termination-rule="terminationRule"
            @form-submitted="updateTerminationRule"
        />
    </DCard>
</template>

<script setup>
import Form from '~@/Components/Products/TerminationRules/Form'
import { route } from '~@/Composables/route'

const props = defineProps({
    errors: {
        type: Object,
        default: () => { return {} }
    },
    terminationRule: {
        type: Object,
        default: () => { return {} }
    }
})

function updateTerminationRule (form) {
    form.put(route('products.termination-rules.update', {
        termination_rule: props.terminationRule.id
    }))
}
</script>
